import { isNil } from "@utils/assert";

export const createSprite = async (canvas: HTMLCanvasElement | null, urls: string[]): Promise<string | undefined> => {
	if (isNil(canvas) || urls.length === 0) return;

	const ctx = canvas.getContext("2d");
	if (!ctx) return;

	const images = await Promise.all(
		urls.map(
			src =>
				new Promise<HTMLImageElement>((resolve, reject) => {
					const img = new Image();

					if (src.startsWith("http")) {
						img.crossOrigin = "anonymous";
					}

					img.src = src;
					img.onload = () => resolve(img);
					img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
				}),
		),
	);

	canvas.width = images.length * images[0].width;
	canvas.height = images[0].height;

	images.forEach((img, index) => {
		ctx.drawImage(img, index * img.width, 0);
	});

	return canvas.toDataURL();
};
